export default {
  title: 'นำเข้าข้อมูล',
  layout: {
    exit_wizard: 'ออกจากตัวช่วย',
    /** @deprecated — bottom-right skip button removed (Q4). Kept to avoid missing-key warnings. */
    skip: 'ข้าม ↗',
    /** @deprecated — Resume Later link removed from mobile drawer (Q4). Kept to avoid missing-key warnings. */
    resume_later: 'กลับมาทำต่อภายหลัง',
    open_menu: 'เปิดเมนู',
    menu: 'เมนู',
    close_menu: 'ปิดเมนู',
  },
  controls: {
    back: 'ย้อนกลับ',
    skip: 'ข้าม',
    next: 'ถัดไป',
  },
  step_bar: {
    aria_label: 'ความคืบหน้าการตั้งค่าเริ่มต้น',
    go_to_step: 'ไปที่ขั้นตอน {{n}}',
    indicators_aria_label: 'ตัวบ่งชี้ขั้นตอน',
    step_aria_label: {
      idle: 'ขั้นตอน {{n}}',
      current: 'ขั้นตอน {{n}} (ปัจจุบัน)',
      completed: 'ขั้นตอน {{n}} (เสร็จสิ้น)',
    },
    step_of: 'ขั้นที่ {{n}} จาก {{total}}',
    labels: {
      '1': 'อสังหาฯ',
      '2': 'ราคา',
      '3': 'ห้อง',
      '4': 'ผู้เช่า',
      '5': 'สัญญา',
      '6': 'มิเตอร์',
      '7': 'บิล',
      '8': 'ชำระ',
    },
  },
  import_wizard: {
    steps: {
      upload: 'อัปโหลด',
      parsing: 'ประมวลผล',
      review: 'ตรวจสอบ',
      confirm: 'นำเข้า',
      result: 'เสร็จสิ้น',
    },
    // EP-115 Q-5: frames 1 and 2 draw DIFFERENT titles on the same screen in two
    // states ("import your rooms" before a file is staged, "import property data"
    // after). A title cannot change when a file is dropped, so one had to win.
    // The flow imports a whole property bundle — property, pricing, rooms,
    // customers, leases — so the property wording is the accurate one.
    page_title_upload: 'นำเข้าข้อมูลอสังหาฯ',
    page_title_review: 'ตรวจสอบข้อมูลอสังหาฯ',
  },
  upload: {
    panel_title: 'อัปโหลดไฟล์',
    // F19/AC-8 (EP-158): no em dash in user-facing copy (owner rule).
    panel_subtitle: 'อัปโหลดไฟล์ Excel หรือ CSV เราจะเติมข้อมูลให้อัตโนมัติ ไม่ต้องกรอกเอง',
    source_system: 'ระบบต้นทาง',
    source_label: 'ระบบต้นทาง',
    // OnboardingUploadCard keys (task-028)
    upload_card: {
      title: 'มีข้อมูลเดิมอยู่แล้วหรือเปล่า?',
      subtitle: 'อัปโหลดสเปรดชีต เราจะกรอกข้อมูลให้ในขั้นตอนถัดไป',
      drop_zone: 'วางไฟล์ .xlsx / .csv ที่นี่ หรือเลือกไฟล์',
      source_label: 'ต้นทาง',
      source_generic: 'ทั่วไป',
      source_horganice: 'Horganice',
      background_note: 'การประมวลผลทำงานเบื้องหลัง กรอกข้อมูล Wizard ต่อได้เลย',
      uploading: 'กำลังอัปโหลด {{filename}}…',
      error_file_too_large: 'ไฟล์ใหญ่เกินไป ขนาดสูงสุด 10MB',
      error_unsupported_format: 'รูปแบบไม่รองรับ กรุณาใช้ .xlsx หรือ .csv',
    },
    source_placeholder: 'เลือกระบบต้นทาง',
    source_generic: 'ทั่วไป',
    source_generic_desc: 'ไฟล์สเปรดชีตใดก็ได้ (CSV/Excel)',
    source_horganice: 'Horganice',
    source_horganice_desc: 'ส่งออกจากระบบ Horganice PMS',
    drop_zone_title: 'คลิกเพื่ออัปโหลดหรือลากและวาง',
    file_type_hint: 'รูปแบบที่รองรับ: .xlsx, .xls, .csv',
    size_limit: 'ขนาดสูงสุด 10 MB ต่อไฟล์',
    auto_layout_note: 'เราอ่านรูปแบบไฟล์โดยอัตโนมัติ ไม่ต้องใช้แม่แบบ',
    add_another: 'เพิ่มไฟล์อื่น',
    // EP-54: Thai has no plural inflection; single base key. _plural removed.
    file_count: 'เลือก {{count}} ไฟล์',
    remove_file: 'ลบ',
    start_import: 'เริ่มนำเข้า',
    uploading: 'กำลังอัปโหลด...',
    errors: {
      source_required: 'กรุณาเลือกระบบต้นทาง',
      files_required: 'กรุณาอัปโหลดอย่างน้อยหนึ่งไฟล์',
      file_too_large: 'ไฟล์ "{{name}}" เกินขีดจำกัด 10 MB',
      invalid_type: 'ไฟล์ "{{name}}" ไม่ใช่รูปแบบที่รองรับ (.xlsx, .xls หรือ .csv)',
      upload_failed: 'การอัปโหลดล้มเหลว กรุณาลองอีกครั้ง',
    },
  },
  parsing: {
    title: 'กำลังประมวลผลไฟล์',
    description: 'ไฟล์ของคุณกำลังถูกประมวลผล อาจใช้เวลาสักครู่',
    progress_label: 'กำลังประมวลผลไฟล์...',
    files_label: 'สถานะไฟล์',
    error_title: 'การประมวลผลล้มเหลว',
    error_description: 'ไม่สามารถประมวลผลไฟล์หนึ่งรายการขึ้นไปได้ กรุณาตรวจสอบไฟล์ของคุณและลองอีกครั้ง',
    // B-009 — แสดงเมื่อการประมวลผลค้างหรือไม่ถูกหยิบไปทำ
    timeout_title: 'การประมวลผลใช้เวลานานกว่าที่คาด',
    timeout_description: 'ตัวประมวลผลยังไม่ตอบสนอง คุณสามารถลองใหม่หรือยกเลิกแล้วเริ่มต้นใหม่ได้',
    try_again: 'ลองอีกครั้ง',
    file_status: {
      pending: 'รอดำเนินการ',
      parsing: 'กำลังประมวลผล',
      parsed: 'เสร็จสิ้น',
      failed: 'ล้มเหลว',
    },
  },
  review: {
    title: 'ตรวจสอบข้อมูลที่ดึงออกมา',
    description: 'ตรวจสอบและแก้ไขข้อมูลที่พบในไฟล์ของคุณก่อนนำเข้า คลิกที่ช่องเพื่อแก้ไข',
    dropped_columns_warning_other: 'ไม่รู้จัก {{count}} คอลัมน์ และจะไม่ถูกนำเข้า: {{columns}}',
    confirm_button: 'ยืนยันและนำเข้า',
    no_data_title: 'ไม่พบข้อมูล',
    no_data_description: 'ไม่พบข้อมูลในไฟล์ของคุณ กรุณาตรวจสอบไฟล์และลองอีกครั้ง',
    entity: {
      properties: 'อสังหาริมทรัพย์',
      room_types: 'ประเภทห้อง',
      units: 'ยูนิต',
      customers: 'ผู้เช่า',
      leases: 'สัญญาเช่า',
    },
    columns: {
      name: 'ชื่อ',
      address: 'ที่อยู่',
      property_name: 'อสังหาริมทรัพย์',
      unit_number: 'เลขห้อง',
      room_type_name: 'ประเภทห้อง',
      floor: 'ชั้น',
      area_sqm: 'พื้นที่ (ตร.ม.)',
      first_name: 'ชื่อ',
      last_name: 'นามสกุล',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      customer_phone: 'โทรศัพท์ผู้เช่า',
      start_date: 'วันเริ่มต้น',
      end_date: 'วันสิ้นสุด',
      rent_amount: 'ค่าเช่า',
    },
  },
  confirm: {
    title: 'ยืนยันการนำเข้า',
    description: 'ตรวจสอบสิ่งที่จะนำเข้าและยืนยันเพื่อเริ่มกระบวนการ',
    warning: 'การดำเนินการนี้ไม่สามารถยกเลิกได้ ข้อมูลทั้งหมดจะถูกสร้างอย่างถาวร',
    summary_title: 'ข้อมูลที่จะถูกสร้าง',
    start_import: 'เริ่มนำเข้า',
    entity: {
      properties: 'อสังหาริมทรัพย์',
      room_types: 'ประเภทห้อง',
      units: 'ยูนิต',
      customers: 'ผู้เช่า',
      leases: 'สัญญาเช่า',
    },
  },
  result: {
    importing_title: 'กำลังนำเข้าข้อมูล',
    importing_description: 'กรุณารอสักครู่ขณะที่ข้อมูลของคุณกำลังถูกนำเข้า อาจใช้เวลาสักครู่',
    success_title: 'นำเข้าสำเร็จ',
    success_description: 'ข้อมูลของคุณถูกนำเข้าสู่ FlowRent เรียบร้อยแล้ว',
    // EP-160: ขอบเขต "ตั้งค่าให้ฉัน" นำเข้าได้เฉพาะแท็บอาคาร ราคา และห้อง
    part_done_title: 'นำเข้าอาคาร ราคา และห้องแล้ว',
    part_done_description: 'แท็บผู้เช่าและสัญญาเช่าให้เจ้าของบัญชียืนยันเองภายหลัง',
    created_summary: 'สร้าง {{properties}} อสังหาริมทรัพย์ {{room_types}} ประเภทห้อง {{units}} ยูนิต {{customers}} ผู้เช่า และ {{leases}} สัญญาเช่า',
    go_to_properties: 'ไปยังอสังหาริมทรัพย์',
    error_title: 'การนำเข้าล้มเหลว',
    // B-009 — แสดงเมื่อการนำเข้า (executor) ค้าง
    timeout_title: 'การนำเข้าใช้เวลานานกว่าที่คาด',
    timeout_description: 'การนำเข้ายังไม่เสร็จสิ้น คุณสามารถลองใหม่หรือยกเลิกแล้วเริ่มต้นใหม่ได้',
    try_again: 'ลองอีกครั้ง',
  },
  chrome: {
    parsing: 'กำลังประมวลผล… ~{{elapsed}}s',
    parsing_short: 'กำลังประมวลผล…',
    cancel: 'ยกเลิก',
    file_ready: '✓ ไฟล์พร้อมแล้ว',
    counts: '{{properties}} อสังหาฯ · {{room_types}} ประเภทห้อง · {{units}} ยูนิต · {{customers}} ผู้เช่า · {{leases}} สัญญา',
    hide: 'ซ่อน',
    parse_failed: '✗ ประมวลผลล้มเหลว: {{reason}}',
    parse_timeout: '✗ ประมวลผลเกินเวลา',
    dismiss: 'ปิด',
  },
  // EP-56 L4 — คำแนะนำแบบ inline แทน spotlight overlay
  hint: {
    // EP-114 T012 — แยกจาก key `step_2` เดิม (บั๊กที่มีอยู่ก่อนแล้ว: คำว่า
    // "ด้านขวา" ผิดบนมือถือมาตั้งแต่ 1.4.2 ที่เปลี่ยนตัวอย่างบิลเป็นปุ่มลอย
    // ไม่ใช่แผงด้านข้าง) เดสก์ท็อปคงข้อความเดิมไว้ทุกตัวอักษร มือถือมีข้อความ
    // ของตัวเองที่อ้างถึงปุ่มลอยแทน แสดงผลแบบมีเงื่อนไขตาม breakpoint ใน
    // OnboardingWizardPage.tsx
    step_3: 'เพิ่มประเภทห้อง (สตูดิโอ, 1BR…) แล้วเพิ่มห้องในแต่ละประเภท ระบุค่ามิเตอร์เริ่มต้นได้เลย',
    step_5: 'ค่าเช่าถูกดึงมาจากห้องที่เลือก ไม่ต้องกรอกซ้ำ',
    step_6: 'ค่ามิเตอร์วันนี้ ลบ ค่ามิเตอร์เริ่มต้น = การใช้งานเดือนนี้',
    step_7: 'บิลแสดงรายการค่าเช่า + สาธารณูปโภค + ค่าธรรมเนียม โดยใช้สูตรราคาและค่ามิเตอร์ที่คุณเพิ่งกรอก คำนวณด้วยเอนจินเดียวกับตัวอย่างใน Step 2 (ซึ่งเป็นตัวเลขตัวอย่าง)',
  },
  apply: {
    banner: 'ไฟล์ของคุณมี {{entityType}} {{count}} รายการ',
    entity_property: 'อสังหาฯ',
    entity_rooms: 'ประเภทห้อง + ห้อง',
    entity_customer: 'ลูกค้า',
    entity_lease: 'สัญญาเช่า',
    entity_pricing: 'รายการราคา',
    button: 'ใช้ข้อมูลจากไฟล์',
  },
  cycle: {
    default_room_type_name: 'ทั่วไป',
    applying_rooms: 'กำลังสร้างประเภทห้องและยูนิตจากไฟล์ของคุณ…',
    applying_customers: 'กำลังดำเนินการนำเข้า {{count}} ลูกค้า',
    applying_leases: 'กำลังดำเนินการนำเข้า {{count}} สัญญา',
    importing_customers: 'มี {{count}} ลูกค้าพร้อมนำเข้า ตรวจสอบแล้วกดถัดไป',
    importing_leases: 'มี {{count}} สัญญาพร้อมนำเข้า ตรวจสอบแล้วกดถัดไป',
    imported_customers: '✓ นำเข้า {{count}} ลูกค้าเรียบร้อย กดถัดไปเพื่อไปยังขั้นตอนสัญญา',
    imported_leases: '✓ นำเข้า {{count}} สัญญาเรียบร้อย กดถัดไปเพื่อไปยังขั้นตอนค่ามิเตอร์',
    batch_skipped_summary: 'ข้าม {{skipped}} จาก {{total}} รายการ เนื่องจากจับคู่ลูกค้า/ห้องไม่ได้',
    batch_no_property: 'ยังไม่พบอสังหาริมทรัพย์ที่บันทึกไว้ กรุณาทำขั้นตอนแรกให้เสร็จก่อน',
    batch_no_readings: 'ไม่มีค่ามิเตอร์ที่จะบันทึก',
    batch_readings_applied: '✓ บันทึกค่ามิเตอร์ {{count}} รายการเรียบร้อย',
    batch_readings_partial:
      '⚠ บันทึกค่ามิเตอร์ได้เพียง {{saved}} จาก {{total}} รายการ กรุณาตรวจสอบค่ามิเตอร์แล้วลองใหม่',
    list: {
      name: 'ชื่อ',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      tenant: 'ผู้เช่า',
      unit: 'ห้อง',
      started_at: 'วันที่เริ่ม',
      ended_at: 'วันที่สิ้นสุด',
      deposit: 'เงินประกัน',
      untitled: '(ไม่มีชื่อ)',
    },
    header: {
      customer: 'ลูกค้า {{idx}} จาก {{total}}',
      lease: 'สัญญา {{idx}} จาก {{total}}',
    },
    action: {
      save_next: 'บันทึกและถัดไป',
      skip: 'ข้าม',
      save_all_remaining: 'บันทึกทั้งหมดที่เหลือ',
    },
    confirm_save_all: {
      title: 'บันทึก {{count}} {{entityType}} ที่เหลือทั้งหมด?',
      body: 'ระบบจะสร้างตามลำดับโดยไม่มีการตรวจสอบ หากรายการใดล้มเหลว การประมวลผลจะหยุดที่แถวนั้น',
      yes: 'ใช่ บันทึกทั้งหมด',
    },
    missing_dependency: 'ข้อมูลที่จำเป็นหายไป กรุณาเลือก {{entityType}} ด้วยตนเอง',
    batch_error_prefix_customer: 'ลูกค้า {{idx}}: ',
    batch_error_missing_dependency: 'สัญญา {{idx}}: ข้อมูลที่จำเป็นหายไป กรุณาเลือกห้องหรือลูกค้าด้วยตนเอง',
    batch_error_prefix_lease: 'สัญญา {{idx}}: ',
  },
  wizard: {
    step_1_title: 'ข้อมูลเกี่ยวกับอสังหาฯ ของคุณ',
    step_1_body: 'อสังหาริมทรัพย์คืออาคารหรือหมู่บ้านที่คุณดูแล กรอกข้อมูลพื้นฐาน เช่น ชื่อ ที่อยู่ และเลขประจำตัวผู้เสียภาษี',
    // EP-114 S1-13 — helper notice under the billing-day field (also rendered
    // on the standalone property pages, per D-2).
    step_1_billing_day_note: 'อัตราค่าไฟ ค่าน้ำ และค่าสาธารณูปโภคอื่นๆ ตั้งค่าได้ทีหลังในหน้า "กำหนดราคา"',
    step_2_title: 'ตั้งค่าราคา',
    // EP-114 T010 — replaces the retired step-2 explainer-body key (orphaned,
    // never rendered). Rendered by PropertyPricingFields' streamlinedMode info
    // banner, not the wizard chrome. Verbatim from Figma node
    // 183:1864 (title) / 183:1868 (body) — do not re-type by hand.
    step_2_formula_banner_title: 'สูตรราคา',
    step_2_formula_banner_body: 'สูตรราคา = วิธีคำนวณค่าเช่า + สาธารณูปโภค + ค่าธรรมเนียมในแต่ละเดือน เราได้ตั้งค่าเริ่มต้นสำหรับอพาร์ตเมนต์ไทยทั่วไปไว้ให้แล้ว ปรับอัตราให้ตรงกับของคุณได้เลย ตัวอย่างบิลจะแสดงผลแบบเรียลไทม์',
    // EP-114 T012 (S2-8) — แถวคำแนะนำใหม่ภายในแผงราคาของขั้นตอนที่ 2
    // แสดงผลเหมือนกันทุกประการทั้งบนมือถือและเดสก์ท็อป จึงต้องไม่อ้างอิงตำแหน่ง
    // ของตัวอย่างบิล (ซึ่งต่างกันตาม breakpoint — แผงด้านข้างบนเดสก์ท็อป
    // ปุ่มลอยบนมือถือ)
    step_2_rates_hint: 'แก้ไขอัตราใดก็ได้ ตัวอย่างบิลจะคำนวณใหม่ทันที',
    step_3_title: 'เพิ่มห้องและยูนิต',
    step_3_body: 'สร้างประเภทห้อง (สตูดิโอ ห้อง 1 นอน ฯลฯ) และยูนิตต่างๆ ภายในแต่ละประเภท แต่ละยูนิตสามารถมีมิเตอร์น้ำและไฟฟ้า พร้อมบันทึกค่ามิเตอร์เปิดได้ทันที',
    step_4_title: 'เพิ่มลูกค้าคนแรก',
    step_4_body: 'ลูกค้าคือผู้ที่เช่าห้องจากคุณ ป้อนชื่อ เบอร์โทร และอีเมล เพื่อให้สามารถส่งใบแจ้งหนี้และแจ้งเตือนได้ในภายหลัง',
    step_5_title: 'สร้างสัญญาเช่า',
    step_5_body: 'สัญญาเช่าเชื่อมโยงลูกค้ากับยูนิตในช่วงเวลาที่กำหนด พร้อมระบุเงินประกัน ค่าเช่าจะถูกดึงมาจากยูนิตที่ตั้งค่าในขั้นตอนที่ 3 โดยอัตโนมัติ',
    step_6_title: 'บันทึกตัวเลขมิเตอร์',
    step_6_body: 'ขั้นตอนที่ 3 บันทึกค่ามิเตอร์เปิดไว้แล้ว ตอนนี้บันทึกค่ามิเตอร์วันนี้เพื่อคำนวณการใช้งานในเดือนนี้ บิลจะคิดจากส่วนต่างระหว่างค่าสองครั้ง',
    step_7_title: 'สร้างใบแจ้งหนี้แรก',
    step_7_body: 'สูตรราคา × การใช้งานวันนี้ + ค่าเช่า + ค่าธรรมเนียม = ใบแจ้งหนี้แบบแยกรายการ กด "สร้าง" เพื่อดูผลลัพธ์',
    step_8_title: 'บันทึกการชำระเงินครั้งแรก',
    step_8_body: 'เมื่อผู้เช่าชำระเงิน บันทึกการชำระเงินนี้ตรงกับใบแจ้งหนี้ที่สร้างไว้ สามารถตรวจสอบสลิปเพิ่มเติมได้ภายหลังจากหน้ารายละเอียดการชำระเงิน',
    no_units_warning: 'กรุณาเพิ่มยูนิตอย่างน้อยหนึ่งรายการก่อนดำเนินการต่อ',
    step_3_select_unit_error: 'เลือกยูนิตที่ว่างเพื่อดำเนินการต่อ',
    step_saved: 'บันทึกแล้ว',
    // EP-158 F1/AC-1: shown on step 5 when the operator went back and picked
    // a different room or tenant, but the lease already has an invoice (or
    // is no longer draft) so the change is refused — editing continues on
    // the original lease.
    step_5_lease_locked_warning: 'ไม่สามารถเปลี่ยนห้องหรือผู้เช่าของสัญญานี้ได้ เนื่องจากมีใบแจ้งหนี้แล้ว คุณกำลังแก้ไขสัญญาเดิมอยู่',
    // EP-158 F18/AC-12: step 8 for an invoice with no balance due.
    step_8_invoice_paid: 'ใบแจ้งหนี้นี้ชำระครบแล้ว',
    condo_skip_meters_title: 'ข้ามขั้นตอนการบันทึกค่ามิเตอร์',
    condo_skip_meters_body: 'คอนโดมิเนียมใช้มิเตอร์รวมในระดับอาคาร แต่ละห้องจึงไม่ต้องบันทึกค่ามิเตอร์เอง ค่าส่วนกลางจะคิดจากรายการ CommonAreaFee ที่ตั้งไว้ในอาคารแทน',
    step6_import_title: 'นำเข้าค่ามิเตอร์จากไฟล์',
    step6_import_body: 'ตรวจสอบค่ามิเตอร์ของ {{count}} ห้องที่ดึงมาจากไฟล์ที่อัปโหลด ค่าเหล่านี้จะถูกบันทึกเป็นค่าเริ่มต้น ค่าเดือนถัดไปจะคำนวณการใช้งานจากค่านี้',
    step6_import_unmatched: 'ข้าม {{count}} รายการ เนื่องจากอ้างอิงห้องที่ยังไม่ถูกสร้าง',
    step6_col_unit: 'ห้อง',
    step6_col_water: 'มิเตอร์น้ำ (ปัจจุบัน)',
    step6_col_electricity: 'มิเตอร์ไฟ (ปัจจุบัน)',
    step6_group_water: 'มิเตอร์น้ำ',
    step6_group_electricity: 'มิเตอร์ไฟ',
    step6_col_initial: 'ตั้งต้น',
    step6_col_curr: 'ปัจจุบัน',
    step6_apply_button: 'บันทึกค่ามิเตอร์ทั้งหมด',
    dirty_confirm_title: 'มีการเปลี่ยนแปลงที่ยังไม่บันทึก',
    dirty_confirm_message: 'บันทึกก่อนดำเนินการต่อ?',
    // EP-69 T1.1 — step-1 adopt/prefill + 2+ choice
    step_1_adopted_notice: 'คุณมีอสังหาฯ อยู่แล้ว ตรวจสอบแล้วดำเนินการต่อได้เลย',
    step_1_has_properties_notice: 'คุณมีอสังหาฯ อยู่แล้ว ต้องการทำอะไร?',
    step_1_use_existing: 'ใช้อสังหาฯ ที่มีอยู่',
    step_1_create_new: 'สร้างใหม่',
    step_1_select_property: 'เลือกอสังหาริมทรัพย์',
    step_1_use_this_property: 'ใช้อสังหาฯ นี้',
    // EP-69 T1.2 — step-4 existing-customer picker
    step_4_picker_label: 'เลือกลูกค้าที่มีอยู่',
    step_4_search_placeholder: 'ค้นหาด้วยชื่อหรือเบอร์โทร…',
    step_4_use_this_customer: 'ใช้ลูกค้ารายนี้',
    step_4_create_new: '+ สร้างลูกค้าใหม่',
    step_4_back_to_picker: '← เลือกลูกค้าที่มีอยู่',
    step_4_selected_notice: 'กดถัดไปเพื่อใช้ลูกค้านี้ จะไม่มีการสร้างรายการใหม่',
    step_4_empty_state: 'ยังไม่มีลูกค้า กรอกข้อมูลด้านล่างเพื่อเพิ่มคนแรก',
    step_4_duplicate_name_warning: 'มีลูกค้าชื่อ "{{name}}" อยู่แล้ว',
    step_4_duplicate_view_link: 'ดู',
  },

  // T005 — EP-86 Scenario 1: หน้าเลือกโหมด (ไม่มี ?step / ?import / ?mode)
  explore: {
    seeding: {
      title: 'กำลังสร้างข้อมูลทดสอบ…',
      creating_property: 'สร้างอสังหาริมทรัพย์',
      adding_room_unit: 'เพิ่มประเภทห้องและยูนิต',
      adding_tenant: 'เพิ่มผู้เช่าตัวอย่าง',
      creating_lease: 'สร้างสัญญาเช่า',
      generating_invoice: 'สร้างใบแจ้งหนี้แรก',
      finishing: 'กำลังเสร็จสิ้น',
    },
    hub: {
      title: 'ข้อมูลทดสอบพร้อมแล้ว ปรับให้เป็นของคุณ',
      subtitle:
        'เราสร้างตัวอย่างทุกอย่างด้วยค่าเริ่มต้น เปิดแต่ละรายการเพื่อปรับให้ตรงกับอสังหาฯ ของคุณ (สามารถทำภายหลังจากแดชบอร์ดได้เช่นกัน)',
      property: 'อสังหาริมทรัพย์',
      property_hint: 'ชื่อ ที่อยู่ เลขผู้เสียภาษี และวันออกบิล',
      rooms_and_units: 'ห้องและยูนิต',
      rooms_and_units_hint: 'ยูนิตและค่าเช่าจริง',
      tenant: 'ผู้เช่า',
      tenant_hint: 'ชื่อและเบอร์โทรจริง',
      lease: 'สัญญาเช่า',
      lease_hint: 'วันเริ่ม เงินประกัน และระยะสัญญา',
      invoice: 'ใบแจ้งหนี้',
      invoice_hint: 'ตรวจสอบรายการที่สร้างขึ้น',
      review: 'ตรวจสอบ →',
      go_to_dashboard: 'ไปยังแดชบอร์ด',
      delete_and_start_fresh: 'ลบและเริ่มต้นใหม่',
    },
    delete: {
      title: 'ลบข้อมูลตัวอย่าง?',
      loading: 'กำลังตรวจสอบข้อมูลตัวอย่าง…',
      load_failed: 'ตรวจสอบข้อมูลตัวอย่างไม่สำเร็จ ลองอีกครั้ง',
      retry: 'ลองอีกครั้ง',
      counts_lead: 'จะลบเฉพาะข้อมูลตัวอย่าง:',
      nothing_to_delete: 'ไม่มีข้อมูลตัวอย่างเหลือให้ลบ',
      own_kept: 'ข้อมูลของคุณเอง (อาคาร {{count}}) จะยังอยู่ครบ',
      blocked_title: 'ยังลบข้อมูลตัวอย่างไม่ได้',
      blocker: 'ลบไม่ได้: {{type}} {{label}} (ของคุณเอง) ใช้{{depends_type}}ตัวอย่าง {{depends_label}}',
      blockers_more: 'และอีก {{count}} รายการ',
      blocked_hint_lease: 'ย้ายสัญญาไปห้องของคุณก่อน แล้วลองใหม่',
      blocked_hint: 'แก้รายการของคุณข้างบนให้ไม่ใช้ข้อมูลตัวอย่างก่อน แล้วลองใหม่',
      needs_flowrent: 'ติดต่อ FlowRent เพื่อลบข้อมูลตัวอย่าง',
      delete_failed: 'ลบข้อมูลตัวอย่างไม่สำเร็จ ลองอีกครั้ง',
      cancel: 'ยกเลิก',
      close: 'ปิด',
      delete: 'ลบข้อมูลตัวอย่าง',
      deleting_title: 'กำลังลบข้อมูลตัวอย่าง…',
      deleting_body: 'กำลังลบเฉพาะข้อมูลตัวอย่าง อาจใช้เวลาสักครู่',
      tables: {
        properties: 'อาคาร {{count}}',
        room_types: 'ประเภทห้อง {{count}}',
        units: 'ห้อง {{count}}',
        meters: 'มิเตอร์ {{count}}',
        readings: 'ค่ามิเตอร์ที่จด {{count}}',
        customers: 'ผู้เช่า {{count}}',
        leases: 'สัญญา {{count}}',
        invoices: 'ใบแจ้งหนี้ {{count}}',
        invoice_items: 'รายการในใบแจ้งหนี้ {{count}}',
        payments: 'การชำระเงิน {{count}}',
        vendors: 'ผู้ให้บริการ {{count}}',
        equipment: 'อุปกรณ์ {{count}}',
        maintenance_schedules: 'ตารางบำรุงรักษา {{count}}',
        work_orders: 'ใบสั่งงาน {{count}}',
        maintenance_requests: 'แจ้งซ่อม {{count}}',
        journal_entries: 'รายการบันทึกบัญชี {{count}}',
        journal_lines: 'บรรทัดบันทึกบัญชี {{count}}',
        debt_cases: 'เคสติดตามหนี้ {{count}}',
        lease_signatures: 'ลายเซ็นสัญญา {{count}}',
        work_order_parts: 'อะไหล่ในใบสั่งงาน {{count}}',
        parcels: 'พัสดุ {{count}}',
        vehicles: 'ยานพาหนะ {{count}}',
        expenses: 'ค่าใช้จ่าย {{count}}',
        other: 'รายการอื่น {{count}}',
      },
      types: {
        property: 'อาคาร',
        room_type: 'ประเภทห้อง',
        unit: 'ห้อง',
        meter: 'มิเตอร์',
        reading: 'ค่ามิเตอร์ที่จด',
        customer: 'ผู้เช่า',
        lease: 'สัญญา',
        invoice: 'ใบแจ้งหนี้',
        invoice_item: 'รายการในใบแจ้งหนี้',
        payment: 'การชำระเงิน',
        vendor: 'ผู้ให้บริการ',
        equipment: 'อุปกรณ์',
        maintenance_schedule: 'ตารางบำรุงรักษา',
        work_order: 'ใบสั่งงาน',
        maintenance_request: 'แจ้งซ่อม',
        journal_entry: 'รายการบันทึกบัญชี',
        journal_line: 'บรรทัดบันทึกบัญชี',
        fixed_asset: 'สินทรัพย์ถาวร',
        debt_case: 'เคสติดตามหนี้',
        other: 'รายการ',
      },
    },
    error: {
      title: 'เกิดข้อผิดพลาด',
      try_again: 'ลองอีกครั้ง',
      go_to_dashboard: 'ไปยังแดชบอร์ด',
    },
    landing: {
      title: 'ยินดีต้อนรับสู่ FlowRent',
      subtitle: 'เลือกวิธีเริ่มต้นที่เหมาะกับคุณ',
      sample: {
        title: 'ลองด้วยข้อมูลตัวอย่างก่อน',
        badge: 'แนะนำ',
        body: 'ระบบจะสร้างหอพัก ผู้เช่า และใบแจ้งหนี้ตัวอย่างให้ทันที ลองคลิกดูได้เลย ลบออกทีหลังได้',
        meta: 'ใช้เวลาประมาณ 20 วินาที',
        button: 'ลองเลย',
      },
      upload: {
        title: 'นำเข้าข้อมูลเดิม',
        body: 'มีรายชื่อห้องหรือผู้เช่าอยู่แล้ว อัปโหลด Excel หรือ CSV ได้เลย',
        meta: 'รองรับ .xlsx และ .csv',
        button: 'อัปโหลดไฟล์',
      },
      scratch: {
        title: 'เริ่มกรอกเอง',
        body: 'ตั้งค่าหอพักทีละขั้น มีตัวช่วยแนะนำตลอด ใช้เวลาประมาณ 5 นาที',
        meta: 'ใช้เวลาประมาณ ~5 นาที',
        button: 'เริ่มตั้งค่า',
      },
    },
  },

  // T007 — EP-86 Scenario 1: แบนเนอร์คำแนะนำที่ปิดได้ในแต่ละหน้า
  // แสดงเมื่อ ?coach=explore อยู่ใน URL และ pageKey ยังไม่ถูกปิด
  coach: {
    dismiss: 'ปิดคำแนะนำ',
    back_to_setup: '← กลับไปยังการตั้งค่า',
    property: {
      title: 'นี่คือข้อมูลตัวอย่าง',
      body: 'เปลี่ยนชื่ออสังหาฯ และกรอกที่อยู่จริง เลขประจำตัวผู้เสียภาษี และวันออกบิล',
    },
    rooms: {
      title: 'นี่คือห้องตัวอย่าง',
      body: 'ตรวจหมายเลขห้องและค่าเช่าให้ตรงกับของจริง',
    },
    tenant: {
      title: 'นี่คือผู้เช่าตัวอย่าง',
      body: 'อัปเดตชื่อและเบอร์โทรด้วยข้อมูลจริง หรือลบผู้เช่านี้แล้วเพิ่มของคุณเอง',
    },
    lease: {
      title: 'นี่คือสัญญาเช่าตัวอย่าง',
      body: 'ปรับวันเริ่ม วันสิ้นสุด เงินประกัน และค่าเช่าให้ตรงกับสัญญาจริงของคุณ',
    },
    invoice: {
      title: 'นี่คือใบแจ้งหนี้ตัวอย่าง',
      body: 'ตรวจสอบรายการที่สร้างโดยสูตรราคาและยืนยันว่ายอดเงินตรงกับการตั้งค่าราคาของคุณ',
    },
  },

  // T020 — EP-86 Scenario 3: แท็บตรวจสอบข้อมูล (ImportReviewTabs).
  // ป้ายกำกับแท็บ, ปุ่มยืนยันแต่ละแท็บ, ปุ่มนำเข้าสุดท้าย, หัวคอลัมน์
  // และข้อความตรวจสอบลิงก์อ้างอิง
  import: {
    tabs: {
      aria_label: 'แท็บตรวจสอบ',
      property: 'อสังหาริมทรัพย์',
      pricing: 'ราคา',
      rooms: 'ห้องและยูนิต',
      customers: 'ลูกค้า',
      leases: 'สัญญาเช่า',
      confirmed: 'ยืนยันแล้ว',
    },
    confirm_tab: 'ยืนยัน{{tab}}',
    // The Pricing tab confirms a FORMULA, not a price, so it does not use the
    // `confirm_tab` interpolation above — "confirm pricing" reads like a
    // single amount is being agreed. Owner wording, 2026-08-05.
    confirm_pricing: 'ยืนยันสูตรคำนวณ',
    import_everything: 'นำเข้าทั้งหมด',
    import_gate: 'ยืนยันข้อมูลก่อน นำเข้า',
    review_panel_title: 'ยืนยันข้อมูลอสังหาฯ',
    review_panel_subtitle: 'เพื่อนำเข้าข้อมูลอสังหาริมทรัพย์ที่มีอยู่ของคุณเข้าสู่ FlowRent',
    columns: {
      // แท็บอสังหาริมทรัพย์
      name: 'ชื่อ',
      address: 'ที่อยู่',
      tax_id: 'เลขผู้เสียภาษี',
      branch_number: 'สาขา',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      location_url: 'URL แผนที่',
      // แท็บห้องและยูนิต
      unit_number: 'เลขห้อง',
      room_type_name: 'ประเภทห้อง',
      price: 'ราคา',
      area_sqm: 'พื้นที่ (ตร.ม.)',
      // แท็บลูกค้า
      first_name: 'ชื่อ',
      last_name: 'นามสกุล',
      // แท็บสัญญาเช่า
      tenant_name: 'ผู้เช่า',
      started_at: 'วันเริ่ม',
      ended_at: 'วันสิ้นสุด',
      rent_amount: 'ค่าเช่า',
      deposit_amount: 'เงินประกัน',
      move_in_fee_amount: 'ค่าแรกเข้า',
      keycard_deposit_amount: 'เงินมัดจำคีย์การ์ด',
    },
    // EP-158 D2 (2026-10-09): สัญญาเช่าที่นำเข้าและมีสถานะ active จะถูกบันทึกว่า
    // เก็บเงินประกันครบแล้วโดยอัตโนมัติ (ตัดสินจากสถานะของสัญญาเช่าเอง ไม่ใช่จาก
    // checkbox) แทนที่ checkbox ระดับไฟล์และคอลัมน์รายแถวที่ถูกลบไป
    leases_note: 'สัญญาที่เริ่มแล้วและยังไม่สิ้นสุด จะบันทึกว่าเก็บเงินประกันครบแล้ว',
    validation: {
      unit_not_found: 'ไม่พบห้องในแท็บห้องและยูนิต',
      tenant_not_found: 'ไม่พบผู้เช่าในแท็บลูกค้า',
    },
    // ตัวเลือกเริ่มต้นของ dropdown สำหรับเชื่อมสัญญาเช่ากับห้อง / ลูกค้า
    link: {
      source_tab_empty: 'แท็บนั้นยังไม่มีข้อมูล กรุณากรอกก่อนแล้วกลับมาเชื่อมโยง',
      no_match: 'ไม่พบข้อมูลที่ตรงกันในไฟล์นี้',
      select_unit: 'เลือกห้อง…',
      select_customer: 'เลือกลูกค้า…',
    },
    // T021 — ข้อความวนซ้ำหลายอสังหาริมทรัพย์
    property_k_of_n: 'อสังหาริมทรัพย์ {{k}} จาก {{n}}',
    n_more_waiting: 'อีก {{n}} รายการรอดำเนินการ',
    continue_with_next: 'ดำเนินการกับอสังหาริมทรัพย์ถัดไป',
    finish: 'เสร็จสิ้น',
    all_imported: 'นำเข้า {{count}} อสังหาริมทรัพย์ทั้งหมดแล้ว',
    skipped_leases: {
      title: 'มี {{count}} แถวสัญญาเช่าที่ไม่ได้นำเข้า',
      description:
        'แถวเหล่านี้ขาดข้อมูลที่จำเป็นในการสร้างสัญญาเช่า แก้ไขในไฟล์แล้วนำเข้าอีกครั้ง หรือเพิ่มสัญญาเช่าเอง',
      unit: 'ห้อง',
      tenant: 'ผู้เช่า',
      reason: 'สาเหตุ',
      unknown_tenant: 'ไม่ระบุ',
      reasons: {
        unit_not_found: 'ไม่พบห้องนี้ในไฟล์',
        no_phone: 'ไม่มีเบอร์โทรสำหรับจับคู่ผู้เช่า',
        tenant_not_found: 'เบอร์โทรไม่ตรงกับผู้เช่าคนใด',
      },
    },
    reassigned_building_rows: {
      title: 'มี {{count}} แถวที่ถูกจัดเข้าอาคารแรกให้อัตโนมัติ',
      description:
        'แถวเหล่านี้ไม่มีการระบุอาคารในไฟล์ ระบบจึงจัดให้อยู่ในอาคารแรก กรุณาตรวจสอบว่าแต่ละแถวอยู่ในอาคารที่ถูกต้อง',
      unit: 'ห้อง',
      tenant: 'ผู้เช่า',
      assigned_to: 'จัดเข้าอาคาร',
      unknown_tenant: 'ไม่ระบุ',
    },
    // T149-078 addition (MON-7 C import UI): สัญญาเช่าที่บันทึกเงินประกันที่เก็บไว้ก่อนใช้ FlowRent
    // ไม่สำเร็จระหว่างนำเข้า (ตัวสัญญาเช่าเองนำเข้าสำเร็จ)
    deposit_held_failed_rows: {
      title: 'ยังไม่ได้บันทึกเงินประกันที่เก็บไว้',
      description:
        'สัญญาเช่าเหล่านี้นำเข้าสำเร็จ แต่บันทึกเงินประกันที่เก็บไว้ก่อนใช้ FlowRent ไม่สำเร็จ กรุณาบันทึกด้วยตนเองจากแต่ละสัญญาเช่า',
      property: 'อาคาร',
      unit: 'ห้อง',
      customer: 'ลูกค้า',
      reason: 'สาเหตุ',
      unknown_customer: 'ไม่ระบุ',
      action_link: 'ไปที่สัญญาเช่า',
    },
    go_to_properties: 'ไปยังอสังหาริมทรัพย์',
    grid: {
      aria_label: 'ตารางกริดข้อมูล',
      add_row: 'เพิ่มแถว',
      delete_row: 'ลบแถว',
      row_count_other: '{{count}} แถว',
    },
  },

  // EP-56 L2 — โหมดตัวอย่าง (ไม่ต้องป้อนข้อมูล) เข้าผ่าน ?mode=sample
  sample_mode: {
    see_sample_button: 'ดูตัวอย่างใบแจ้งหนี้ (ไม่ต้องป้อนข้อมูล)',
    title: 'โหมดตัวอย่าง ไม่มีการบันทึก',
    body: 'ตัวเลขเหล่านี้มาจากตัวอย่างห้องสตูดิโอในกรุงเทพฯ ไม่มีผลต่อบัญชีของคุณ',
    start_fresh: 'เริ่มใหม่',
    invoice_title: 'ตัวอย่างใบแจ้งหนี้ประจำเดือน',
    invoice_subtitle: 'ค่าเช่า ฿5,000 + ค่าน้ำ 10u + ค่าไฟ 50u + ค่าส่วนกลาง 3% = ฿5,695.90',
    col_description: 'รายละเอียด',
    col_qty: 'จำนวน',
    col_rate: 'ราคา/หน่วย',
    col_amount: 'รวม',
    download_csv: 'ดาวน์โหลด CSV',
  },

  // EP-160 S8 คำถาม "ติดตรงไหน?" เมื่อหยุดตั้งค่าเริ่มต้นกลางทาง
  blocker: {
    title: 'ติดตรงไหน?',
    intro: 'บอกเราสักนิด จะได้ช่วยให้ตั้งค่าเสร็จง่ายขึ้น',
    codes: {
      no_time: 'ไม่มีเวลา',
      too_hard: 'ยากเกินไป',
      other_system: 'ข้อมูลอยู่ในระบบอื่น',
      waiting_line: 'รอตั้งค่า LINE',
      price: 'ราคา',
      other: 'อื่นๆ',
    },
    note_label: 'เล่าเพิ่ม (ไม่บังคับ)',
    skip: 'ข้าม',
    send: 'ส่ง',
    error: 'ส่งไม่สำเร็จ ลองอีกครั้ง',
  },
}
